/** Should an ArrowUp/ArrowDown keydown move the Curate paper selection?
 *
 * Not while the full-page PDF viewer is open: the keys belong to the reader
 * there, and switching papers behind the overlay reloaded the viewer
 * (glitches/redraws, 2026-09-27). Also not in form fields or when AG Grid has
 * focus (it handles its own arrows). */
export function shouldArrowNavigatePapers(
  e: KeyboardEvent,
  { pdfMaximized }: { pdfMaximized: boolean },
): boolean {
  if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return false;
  if (pdfMaximized) return false;
  const target = e.target as HTMLElement | null;
  const tag = target?.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return false;
  if (target?.closest?.(".ag-root-wrapper")) return false;
  return true;
}
